$ = require 'jquery'
_ = require 'underscore'
Hearsay = require 'hearsay'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
View = require 'view'

module.exports = class PluginView extends View
  constructor: ->
    @_retained = []
    @_pendingPromises = []
    @_eventListeners = []
    super

  _retainCallback: (callback) ->
    if callback? && @_retained?
      callback.retain().done()
      @_retained.push(callback)
    callback

  retain: (obj) ->
    if _.isFunction(obj)
      @_retainCallback(obj)
    else if _.isArray(obj)
      obj.forEach (item) =>
        @retain(item)
    else if _.isObject(obj)
      @retain _.values(obj)

    return

  cancelOnRemove: (promise) ->
    if @_pendingPromises?
      @_pendingPromises.push(promise)
      promise.then =>
        @_pendingPromises = _.without(@_pendingPromises, promise)
    else
      promise.cancel()
    promise

  remove: ->
    super

    for promise in @_pendingPromises
      promise.cancel()
    delete @_pendingPromises

    for { target, type, callback } in @_eventListeners
      target.removeEventListener type, callback
    delete @_eventListeners

    # Remove these last, since it's possible that a promise or a callback
    # will try to use them
    for retained in @_retained
      retained.release().done()
    delete @_retained

    return

  addEventListener: (target, type, callback) ->
    target.addEventListener type, callback
    @_eventListeners.push({ target, type, callback })

  handleIFrameMessage: null

  initIFrames: (board, card, changedSignals...) ->
    $iframes = @$el.find('iframe.plugin-iframe')

    combinedSignal = Hearsay.combine changedSignals.concat(pluginsChangedSignal(board, card))...

    _.each $iframes, (iframe) =>
      unuseCombinedSignal = combinedSignal.use()

      $iframe = $(iframe)
      $iframe
      .addClass('iframe-loading')
      .one 'load', (e) =>
        $iframe.removeClass('iframe-loading')

        @subscribe combinedSignal, =>
          iframe.contentWindow.postMessage('render', '*')
        unuseCombinedSignal()

        if @handleIFrameMessage?
          @addEventListener window, 'message', (e) =>
            if e.source == iframe.contentWindow
              @handleIFrameMessage(iframe, e.data)
            return
        return
      return
    return



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-view.coffee